// ❗ WARNING please use your access token from mapbox.com
<script setup lang="ts">
import type { LngLatLike } from 'mapbox-gl'
import mapboxgl from 'mapbox-gl'
import { onMounted, ref } from 'vue'
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import { useDisplay } from 'vuetify'
import fleetImg from '@images/misc/fleet-car.png'
import type { external } from '@/schema.d'
import { DrivingTaskStatusEnum } from '@/enums.js'

type GetDrivingTasksResponse =
  external['components/schemas/response/admin/driver/GetDrivingTasksResponse.yaml']
type DrivingTask = external['components/schemas/driver/DrivingTask.yaml']
type DrivingTaskScheduling =
  external['components/schemas/driver/DrivingTaskScheduling.yaml']
type ScheduleCustomerDrivingTasksRequest =
  external['components/schemas/request/admin/driver/ScheduleCustomerDrivingTasksRequest.yaml']

const route = useRoute('apps-ecommerce-logistics-actions-map-date')
const router = useRouter()

const { isLeftSidebarOpen } = useResponsiveLeftSidebar()

const driverColors = [
  'group-marker-blue',
  'group-marker-red',
  'group-marker-aqua',
  'group-marker-violet',
  'group-marker-green',
  'group-marker-fuchsia',
  'group-marker-spring-green',
]

const accessToken
  = 'pk.eyJ1Ijoib3BlcmkiLCJhIjoiY2xzY2I1NmtyMG05eDJxb2F4cG8xamgxYiJ9.Yv1JfI1-rBmD2CsNasITCQ'

const map = ref()
const vuetifyDisplay = useDisplay()

const date = ref<string>()

date.value = route.params.date

const { data: drivingTasksResponse }
  = await useApiOperi<GetDrivingTasksResponse>(
    `driver-admin/driving-task?date=${date.value}`,
  )

const drivingTasks = computed(() => drivingTasksResponse.value?.drivingTasks)

const dailyDrivingGroups = computed(
  () => drivingTasksResponse.value?.drivingDailyGroups,
)

// const { data: driversData } = await useApiOperi<DriversShallowResponse>(createUrl('admin/drivers'))
// const availableDrivers = computed(() => driversData.value?.driversList?.filter(d => d.status === DriverStatusEnum.AVAILABLE))

definePage({
  meta: {
    layoutWrapperClasses: 'layout-content-height-fixed',
  },
})

const carImgs = ref<Array<string>>([])
const assignedDrivingGroups = ref<Array<number | undefined>>([])
const showPanel = ref<Array<boolean>>([])

drivingTasks.value?.forEach(task => {
  carImgs.value.push(fleetImg)
  showPanel.value.push(false)
  assignedDrivingGroups.value.push(
    task.drivingDailyGroup?.drivingGroupId ?? undefined,
  )
})

assignedDrivingGroups.value.forEach(element => {
  console.log(`ASSIGNED DRIVING GROUPS: ${element}!`)
})

let assignedDrivingGroupsOld = assignedDrivingGroups.value.map(x => x)

const refCars = ref<HTMLElement[]>([])

const activeIndex = ref(0)

const getMarkerForDriver = (
  drivingGroupId: number | null | undefined,
): string => {
  let returnColor = ''
  if (drivingGroupId === undefined || drivingGroupId === null)
    return ''

  console.log(`MARKER DRIVING GROUP ID: ${drivingGroupId}`)
  dailyDrivingGroups.value?.forEach((group, index) => {
    if (group.drivingGroupId === drivingGroupId) {
      console.log(`MARKER DRIVER INDEX: ${index}`)
      returnColor = driverColors.at(index % 7)!
    }
  })

  console.log(`MARKER FOR DRIVING GROUP: ${returnColor}`)

  return returnColor
}

onMounted(() => {
  mapboxgl.accessToken = accessToken

  map.value = new mapboxgl.Map({
    container: 'mapContainer',
    style: 'mapbox://styles/mapbox/light-v9',
    center: [20.456092, 44.801971], // 44.80197121080502, 20.456092938081362
    zoom: 12.25,
  })

  for (let index = 0; index < drivingTasks.value!.length; index++) {
    new mapboxgl.Marker({ element: refCars.value[index] })
      .setLngLat(
        drivingTasks.value?.at(index)?.drivingTask?.coordinates as LngLatLike,
      )
      .addTo(map.value)

    const drivingGroupColor = getMarkerForDriver(
      drivingTasks.value?.at(index)?.drivingDailyGroup?.drivingGroupId,
    )

    if (drivingGroupColor !== '')
      refCars.value[index].classList.add(drivingGroupColor)
  }

  refCars?.value[activeIndex.value]?.classList?.add('blink_me')
})

const flyToLocation = (geolocation: LngLatLike, index: number) => {
  // Store current panel state
  const isPanelCurrentlyOpen = showPanel.value[index]

  // Close all panels
  showPanel.value = showPanel.value.map(() => false)

  // Only open the panel if it was previously closed
  if (!isPanelCurrentlyOpen)
    showPanel.value[index] = true

  activeIndex.value = index

  if (vuetifyDisplay.mdAndDown.value)
    isLeftSidebarOpen.value = false

  map.value.flyTo({
    center: geolocation,
    zoom: 14,
  })
}

const recenter = () => {
  map.value.flyTo({
    center: [20.456092, 44.801971],
    zoom: 12.25,
  })
}

watch(
  assignedDrivingGroups,
  () => {
    console.log('assignDriversNew')
    refCars.value.forEach((car, index) => {
      if (
        assignedDrivingGroups.value[index] !== assignedDrivingGroupsOld[index]
      ) {
        console.log(
          `ASSIGN DRIVERS NEW: ${assignedDrivingGroups.value[index]} ASSIGNED DRIVERS OLD: ${assignedDrivingGroupsOld[index]}`,
        )
        if (getMarkerForDriver(assignedDrivingGroupsOld[index]) !== '') {
          car.classList.remove(
            getMarkerForDriver(assignedDrivingGroupsOld[index]),
          )
        }
        if (
          assignedDrivingGroups.value[index] !== undefined
          && assignedDrivingGroups.value[index] !== null
        ) {
          car.classList.add(
            getMarkerForDriver(assignedDrivingGroups.value[index]),
          )
        }
      }
    })
    assignedDrivingGroupsOld = assignedDrivingGroups.value.map(x => x)
  },
  { deep: true },
)

watch(activeIndex, () => {
  refCars.value.forEach((car, index) => {
    if (index === activeIndex.value)
      car.classList.add('blink_me')
    else car.classList.remove('blink_me')
  })
})

const saveDrivingGroups = async () => {
  const request = ref<ScheduleCustomerDrivingTasksRequest>({
    drivingTasks: new Array<DrivingTaskScheduling>(),
  })

  drivingTasks.value!.forEach((drivingTask, i) => {
    if (
      drivingTask.timeWindows?.length !== 0
      && drivingTask.drivingTask?.time !== null
    ) {
      drivingTask.drivingDailyGroup = {}
      drivingTask.drivingDailyGroup!.drivingGroupId
        = assignedDrivingGroups.value.at(i)!
      drivingTask.drivingTask!.date = date.value
      request.value.drivingTasks!.push(drivingTask)
    }
  })
  await $apiOperi(`driver-admin/driving-task/schedule?date=${date.value}`, {
    method: 'POST',
    body: request.value,
  })

  await router.push({
    name: 'apps-ecommerce-logistics-actions-map-date',
    params: { date: date.value! },
  })
  router.go(0)
}

watch(date, async () => {
  await router.push({
    name: 'apps-ecommerce-logistics-actions-map-date',
    params: { date: date.value! },
  })
  router.go(0)
})

const getColorOfDrivingTruck = (drivingTask: DrivingTask) => {
  if (drivingTask.isOrderOnHold)
    return '#ffec00'

  if (drivingTask.drivingGroupId === null) {
    return ''
  }
  else {
    if (drivingTask.status === DrivingTaskStatusEnum.ACTIVE)
      return '#00abfb'
    else if (drivingTask.status === DrivingTaskStatusEnum.FAILURE)
      return '#ff4500'
    else if (drivingTask.status === DrivingTaskStatusEnum.SUCCESS)
      return '#7bc62d'
    else if (drivingTask.status === DrivingTaskStatusEnum.NOT_STARTED)
      return '#00bfd8'
  }
}
</script>

<template>
  <VCol>
    <VCard>
      <VCardText>
        <AppDateTimePicker
          v-model="date"
          placeholder="Select date"
          :config="{ enableTime: false, dateFormat: 'Y-m-d' }"
        />
      </VCardText>
    </VCard>
  </VCol>
  <VLayout class="fleet-app-layout">
    <VNavigationDrawer
      v-model="isLeftSidebarOpen"
      width="320"
      absolute
      touchless
      location="start"
    >
      <VCard
        class="fleet-navigation-drawer"
        flat
      >
        <!-- Fixed Header -->
        <VCardItem>
          <VRow>
            <VCol cols="3">
              <VCardTitle>Fleet</VCardTitle>
            </VCol>
            <VCol cols="3">
              <div class="d-flex justify-start">
                <VBtn
                  type="submit"
                  color="primary"
                  class="me-4"
                  @click="saveDrivingGroups"
                >
                  Save
                </VBtn>
                <!--
                  <VBtn
                  color="error"
                  variant="tonal"
                  @click="resetForm"
                  >
                  Discard
                  </VBtn>
                -->
              </div>
            </VCol>
            <VCol>
              <IconBtn @click="recenter">
                <VIcon icon="tabler-focus-centered" />
              </IconBtn>
            </VCol>
          </VRow>
          <template #append>
            <IconBtn
              class="d-lg-none navigation-close-btn"
              @click="isLeftSidebarOpen = !isLeftSidebarOpen"
            >
              <VIcon icon="tabler-x" />
            </IconBtn>
          </template>
        </VCardItem>

        <!-- Fleet Section with Scrollbar -->
        <VCardText>
          <div class="fleet-section">
            <PerfectScrollbar>
              <div
                v-for="(drivingTask, index) in drivingTasks"
                :key="index"
                class="mb-6"
              >
                <div
                  class="d-flex align-center justify-space-between cursor-pointer"
                  @click="
                    flyToLocation(
                      drivingTask.drivingTask?.coordinates as LngLatLike,
                      index,
                    )
                  "
                >
                  <div class="d-flex gap-x-4">
                    <VAvatar
                      :icon="
                        drivingTask.drivingTask?.drivingActions?.at(0)
                          ?.actionType === 'DELIVERY'
                          ? 'tabler-truck-delivery'
                          : 'tabler-truck-return'
                      "
                      variant="tonal"
                      :color="getColorOfDrivingTruck(drivingTask.drivingTask)"
                    />
                    <div>
                      <div class="text-body-1 text-high-emphasis font-weight-medium">
                        {{
                          `Order #${drivingTask.drivingTask?.drivingActions?.[0].orderCode ?? drivingTask.drivingTask?.drivingActions?.[0].orderId}`
                        }}
                      </div>
                      <div class="text-body-1 text-high-emphasis font-weight-medium">
                        {{
                          `${drivingTask.drivingTask?.streetName} ${drivingTask.drivingTask?.streetNumber}`
                        }}
                      </div>
                      <div class="text-body-1 text-disabled">
                        {{
                          drivingTask.drivingTask?.drivingActions?.at(0)
                            ?.actionType
                        }}
                      </div>
                      <div
                        v-if="drivingTask.drivingTask.drivingGroupId !== null"
                        class="text-body-1 text-disabled"
                      >
                        {{ drivingTask.drivingTask?.status }}
                      </div>
                      <div
                        v-if="drivingTask.drivingTask?.isOrderOnHold"
                        class="text-body-1 text-disabled"
                      >
                        <RouterLink
                          :to="{
                            name: 'apps-ecommerce-order-details-id',
                            params: {
                              id: drivingTask.drivingTask?.drivingActions?.[0]
                                .orderId!,
                            },
                          }"
                          class="font-weight-medium"
                        >
                          On Hold - Resolve
                        </RouterLink>
                      </div>
                    </div>
                  </div>
                  <IconBtn density="comfortable">
                    <VIcon
                      :icon="
                        showPanel[index]
                          ? 'tabler-chevron-down'
                          : $vuetify.locale.isRtl
                            ? 'tabler-chevron-left'
                            : 'tabler-chevron-right'
                      "
                    />
                  </IconBtn>
                </div>
                <VExpandTransition
                  v-if="!drivingTask.drivingTask?.isOrderOnHold"
                  mode="out-in"
                >
                  <div v-show="showPanel[index]">
                    <VCol cols="12">
                      <AppSelect
                        v-if="drivingTask.timeWindows?.length !== 0"
                        v-model="assignedDrivingGroups[index]"
                        label="Driving Group"
                        :items="dailyDrivingGroups"
                        :item-title="(item) => item.drivingGroupName"
                        :item-value="(item) => item.drivingGroupId"
                        clearable
                        clear-icon="tabler-x"
                        placeholder="Select Driving Group"
                      />
                      <AppSelect
                        v-if="drivingTask.timeWindows?.length === 0"
                        v-model="assignedDrivingGroups[index]"
                        label="Driving Group"
                        :items="dailyDrivingGroups"
                        :item-title="(item) => item.drivingGroupId"
                        :item-value="(item) => item.drivingGroupId"
                        readonly="true"
                        clearable
                        clear-icon="tabler-x"
                        placeholder="Select Driving Group"
                      />
                    </VCol>
                    <VCol cols="12">
                      <AppDateTimePicker
                        v-if="drivingTask.timeWindows?.length !== 0"
                        v-model="drivingTask!.drivingTask!.time"
                        label="Time picker"
                        placeholder="Select time"
                        clearable
                        clear-icon="tabler-x"
                        :config="{
                          enableTime: true,
                          noCalendar: true,
                          dateFormat: 'H:i',
                        }"
                      />
                      <AppDateTimePicker
                        v-if="drivingTask.timeWindows?.length === 0"
                        v-model="drivingTask!.drivingTask!.time"
                        readonly="true"
                        clearable
                        clear-icon="tabler-x"
                        label="Time picker"
                        placeholder="Select time"
                        :config="{
                          enableTime: true,
                          noCalendar: true,
                          dateFormat: 'H:i',
                        }"
                      />
                    </VCol>
                    <VCol cols="12">
                      <div
                        v-for="(timeWindow, index2) in drivingTask.timeWindows"
                        :key="index2"
                      >
                        <div class="text-caption text-uppercase text-success font-weight-medium">
                          {{
                            `Start: ${timeWindow.startTime} End: ${timeWindow.endTime}`
                          }}
                        </div>
                      </div>
                    </VCol>

                    <VCol cols="12">
                      <div class="text-body-1 text-disabled">
                        Instructions:
                        {{ drivingTask.drivingTask?.instructions }}
                      </div>
                    </VCol>
                  </div>
                </VExpandTransition>
              </div>
            </PerfectScrollbar>
          </div>
        </VCardText>
      </VCard>
    </VNavigationDrawer>

    <VMain>
      <div class="h-100">
        <IconBtn
          class="d-lg-none navigation-toggle-btn rounded-sm"
          variant="elevated"
          @click="isLeftSidebarOpen = true"
        >
          <VIcon icon="tabler-menu-2" />
        </IconBtn>
        <!-- 👉 Fleet map  -->
        <div
          id="mapContainer"
          class="basemap"
        />

        <img
          v-for="(car, index) in carImgs"
          :key="index"
          ref="refCars"
          :src="car"
          alt="car Img marker"
          height="42"
          width="20"
        >
      </div>
    </VMain>
  </VLayout>
</template>

<style lang="scss">
@use "@styles/variables/_vuetify.scss";
@use "@core/scss/base/_mixins.scss";
@import "mapbox-gl/dist/mapbox-gl.css";

.fleet-app-layout {
  border-radius: vuetify.$card-border-radius;

  @include mixins.elevation(vuetify.$card-elevation);

  $sel-fleet-app-layout: &;

  @at-root {
    .skin--bordered {
      @include mixins.bordered-skin($sel-fleet-app-layout);
    }
  }
}

.navigation-toggle-btn {
  position: absolute;
  z-index: 1;
  inset-block-start: 1rem;
  inset-inline-start: 1rem;
}

.navigation-close-btn {
  position: absolute;
  z-index: 1;
  inset-block-start: 1rem;
  inset-inline-end: 1rem;
}

.basemap {
  block-size: 100%;
  inline-size: 100%;
}

.group-marker-blue {
  filter: drop-shadow(0 0 7px blue);
}

.group-marker-red {
  filter: drop-shadow(0 0 7px red);
}

.group-marker-aqua {
  filter: drop-shadow(0 0 7px aqua);
}

.group-marker-violet {
  filter: drop-shadow(0 0 7px blueviolet);
}

.group-marker-green {
  filter: drop-shadow(0 0 7px green);
}

.group-marker-fuchsia {
  filter: drop-shadow(0 0 7px fuchsia);
}

.group-marker-spring-green {
  filter: drop-shadow(0 0 7px springgreen);
}

.blink_me {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.5;
  }
}

.mapboxgl-ctrl-bottom-left,
.mapboxgl-ctrl-bottom-right {
  display: none;
}

.fleet-navigation-drawer {
  .fleet-section {
    height: 50vh; // Adjust this height as needed
    position: relative;
    overflow: hidden;

    .ps {
      height: 100%;
    }
  }
}

#mapContainer {
  block-size: 70vh !important;
}
</style>
